module.exports = __webpack_public_path__ + "img/qr4.6e586f29.png";